import ProfileTypePage from "marketplace/_views/profiles/profile-type-page";
import { ProfileTableData } from "marketplace/_views/profiles/profile-table-data";
import { PageTab } from "marketplace/_views/profiles/profiles-page-tabs";
import { useTeamProfileStore } from "marketplace/_views/profiles/use-marketplace-profile-store";
import Team from "marketplace/teams/team";
import { getSessionPermissions } from "permissions/_stores/permissions-redux-slice";
import { useCallback } from "react";
import { useSelector } from "react-redux";
import { useSession } from "users/__session/session-context";
import { AccountType } from "users/account-types/account-type";

export default function TeamProfilesPage() {
  const sessionPermissions = useSelector(getSessionPermissions);
  const profileStore = useTeamProfileStore();
  const session = useSession();

  const getShouldDisableRowEditing = useCallback(
    (profile: ProfileTableData): boolean =>
      profile instanceof Team && !profile?.leader?.userId?.isEqualTo(session.user?.id),
    [session.user?.id],
  );

  return (
    <ProfileTypePage
      activeTab={PageTab.Teams}
      addProfileDisabled={
        !sessionPermissions?.includesReadAccessToMarketplace ||
        session.accountType === AccountType.Client ||
        (profileStore.individualProfiles !== undefined && profileStore.individualProfiles.length < 1)
      }
      addProfileDisabledMessage={getAddProfileDisabledMessage(profileStore.individualProfiles)}
      getShouldDisableRowEditing={getShouldDisableRowEditing}
      profileStore={profileStore}
    />
  );
}

function getAddProfileDisabledMessage(individualProfiles?: unknown[]): string {
  if (individualProfiles !== undefined && individualProfiles.length < 1) {
    return "You must create an individual profile before creating a vendor-team";
  }
  return "";
}
